
import avatar from '@/assets/images/public/user-circle.png';
import AppLink from '@/components/common/link'; 
import appConfig from '@/config/app';
import store from '@/store';

const page = {
    data() {
        return {
            appHost:'/',
            avatar: avatar,
            nickname:''
        }
    },
    props: {
    },
    components: { AppLink },
    computed: {},
    methods: {
        async logout() {
            const href = appConfig.domain.app;
            await this.$store.dispatch("user/logout").then(() => {
                document.location.href = href;
            }); 
        },
        linkAccount() {
            this.$router.push({ path: '/account/index' });
        }
    },
	created: function () {
        this.appHost = appConfig.domain.app; 
        const userInfo = store.getters.userInfo;
        if (userInfo) {
            if(userInfo.avatar) {
                this.avatar = userInfo.avatar;
            } 
            this.nickname = userInfo.nickname;
        }
	}
}
export default page


// WEBPACK FOOTER //
// ./src/layout/master/components/navbar/index.js